// Vocabulario háptico de MiPAE — la vibración es CONFIRMACIÓN de registro, no
// ornamento. Regla de uso: solo vibra cuando algo quedó registrado (un dato
// guardado, un hito alcanzado); nunca en taps de navegación. Así la señal
// conserva significado y no desensibiliza en un turno nocturno.
//
// Dos motores, un vocabulario:
//  - App instalada: @capacitor/haptics (el Taptic Engine en iPhone, el motor
//    del sistema en Android). Hasta el 2026-09-03 la háptica iba SOLO por
//    navigator.vibrate, y en el WebView de iPhone esa API no existe: en un
//    iPhone la app no vibraba nunca, y el vocabulario de abajo era letra
//    muerta. Se detectó en la primera ronda de TestFlight.
//  - Web: navigator.vibrate, best-effort (Android/Chrome la soportan, Safari
//    la ignora). La respuesta VISUAL nunca depende de la háptica.
//
// "LOGRO" es para hitos grandes (evolución completa, cierre de turno); los
// call-sites deben cuidar dispararlo con moderación (máx. ~1 vez por sesión).
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNative } from "./platform";

function vibrarWeb(patron) {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(patron);
    }
  } catch { /* noop: la háptica jamás rompe el flujo */ }
}

// Las llamadas nativas son async y se sueltan sin esperar: la háptica es un
// efecto lateral, jamás bloquea ni rompe el flujo si el plugin falta.
function nativo(fn) {
  try { Promise.resolve(fn()).catch(() => {}); } catch { /* noop */ }
}

/** Selección que deja algo elegido (no navegación). */
export const TAP = () => (isNative
  ? nativo(() => Haptics.impact({ style: ImpactStyle.Light }))
  : vibrarWeb(12));

/** Un dato quedó guardado (entrada, nota de voz, escala en el paciente). */
export const CONFIRMA = () => (isNative
  ? nativo(() => Haptics.impact({ style: ImpactStyle.Medium }))
  : vibrarWeb(15));

/** Hito del turno (evolución 100%, cierre). Patrón corto-largo-corto. */
export const LOGRO = () => (isNative
  ? nativo(() => Haptics.notification({ type: NotificationType.Success }))
  : vibrarWeb([12, 40, 18]));
